import { FieldContentNode } from '@helo/cms'
import { ScalarContentNode } from '@helo/cms'

import { DateRenderer } from '../../../datatypes/date/DateRenderer'
import { CellRendererProps } from '../table.types'

/**
 * Renders an AG Grid cell as a date.
 */
export const DateCell = ({
  contentNode,
}: CellRendererProps<string | null> & {
  contentNode: FieldContentNode
}) => {
  return (
    <DateRenderer
      contentNode={contentNode.ofType as ScalarContentNode}
      // options={{ ...{ size: 'small' }, ...colDef.options }}
      // context={colDef.context}
    />
  )
}
